import {SelectPromotionType as SelectPromotionTypeNewTheme} from '@/features/Promotions/SelectPromotionType'
import {selectIsNewDesignCountry} from '@/store/slices/countryCodeSlice'
import {useSelector} from 'react-redux'
import SelectPromotionType from './SelectPromotionType'

/**
 * Select Promotion Type editor shell.
 * Selects legacy or new themed list by country.
 * @returns {JSX.Element}
 */
export const SelectPromotionTypeEditor = () => {
  const isNewDesignCountry = useSelector(selectIsNewDesignCountry)

  return isNewDesignCountry ? <SelectPromotionTypeNewTheme /> : <SelectPromotionType />
}
